import { useState, useEffect } from "react";
import * as React from "react";
import classNames from "components/ui/classNames";

export default function BackToTop() {
  const [showScroll, setShowScroll] = useState(false);

  const checkScrollTop = () => {
    if (!showScroll && window.pageYOffset > 400) {
      setShowScroll(true);
    } else if (showScroll && window.pageYOffset <= 400) {
      setShowScroll(false);
    }
  };

  const scrollTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    window.addEventListener("scroll", checkScrollTop);

    return () => {
      window.removeEventListener("scroll", checkScrollTop);
    };
  }, [showScroll]);

  return (
    <div
      aria-hidden={showScroll === false}
      style={{
        display: showScroll ? "flex" : "none",
      }}
      className="fixed bottom-6 right-6 z-[3] cursor-pointer"
    >
      <button
        type="button"
        onClick={scrollTop}
        tabIndex={-1}
        aria-label="Voltar para o topo da página"
        className={classNames(
          "m-0 flex h-12 w-12 cursor-pointer select-none appearance-none",
          "items-center justify-center rounded-full border-none",
          "bg-black p-0 text-white opacity-40 outline-none",
          "hover:animate-wiggle hover:bg-blue-600 hover:opacity-100 hover:shadow-lg hover:transition-shadow",
        )}
      >
        <ArrowUp width={32} height={32} display="flex" />
      </button>
    </div>
  );
}

function ArrowUp(props: React.SVGProps<any>) {
  return (
    <svg
      width={32}
      height={32}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <path d="M12 19V5M5 12l7-7 7 7" />
    </svg>
  );
}
